var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66559 8.72588C2.12762 9.89118 0.304452 12.3457 0.0346229 15.2508C-0.00368483 15.6632 0.335786 16 0.75 16C1.16421 16 1.49546 15.6628 1.54266 15.2513C1.91394 12.0141 4.66337 9.5 8 9.5C11.3366 9.5 14.0861 12.0141 14.4573 15.2513C14.5045 15.6628 14.8358 16 15.25 16C15.6642 16 16.0037 15.6632 15.9654 15.2508C15.6955 12.3457 13.8724 9.89118 11.3344 8.72588C12.3567 7.81038 13 6.48032 13 5C13 2.23858 10.7614 0 8 0C5.23858 0 3 2.23858 3 5C3 6.48032 3.6433 7.81038 4.66559 8.72588ZM9.53383 8.14689C9.03741 8.0505 8.5246 8 8 8C7.4754 8 6.96259 8.0505 6.46617 8.14689C5.30196 7.57838 4.5 6.38284 4.5 5C4.5 3.067 6.067 1.5 8 1.5C9.933 1.5 11.5 3.067 11.5 5C11.5 6.38284 10.698 7.57838 9.53383 8.14689Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.4131a2db56440b3a84dcf41dff3ba06e.svg";
export { ForwardRef as ReactComponent };